import { Toaster } from 'react-hot-toast';
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from 'react-router-dom';

import authService from './services/authService';

import Footer from './components/common/Footer';
import Header from './components/common/Header';

import AdminComplaintDetail from './components/admin/AdminComplaintDetail';
import AdminComplaintList from './components/admin/AdminComplaintList';
import AdminDashboard from './components/admin/AdminDashboard';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import ComplaintDetail from './components/complaint/ComplaintDetail';
import ComplaintForm from './components/complaint/ComplaintForm';
import ComplaintList from './components/complaint/ComplaintList';

const ProtectedRoute = ({ children }) => {
  return authService.isAuthenticated() ? children : <Navigate to="/login" />;
};

const AdminRoute = ({ children }) => {
  const user = authService.getCurrentUser();
  return user && user.role === 'admin' ? (
    children
  ) : (
    <Navigate to="/dashboard" />
  );
};

const App = () => {
  return (
    <Router>
      <div className="min-h-screen flex flex-col">
        <Toaster position="top-right" />
        <Header />
        <main className="flex-1">
          <Routes>
            {/* auth */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            {/* user routes */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <ComplaintList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/complaint/new"
              element={
                <ProtectedRoute>
                  <ComplaintForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/complaint/:id"
              element={
                <ProtectedRoute>
                  <ComplaintDetail />
                </ProtectedRoute>
              }
            />

            {/* admin routes */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminRoute>
                    <AdminDashboard />
                  </AdminRoute>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/complaints"
              element={
                <ProtectedRoute>
                  <AdminRoute>
                    <AdminComplaintList />
                  </AdminRoute>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/complaints/:id"
              element={
                <ProtectedRoute>
                  <AdminRoute>
                    <AdminComplaintDetail />
                  </AdminRoute>
                </ProtectedRoute>
              }
            />

            {/* default */}
            <Route path="/" element={<Navigate to="/dashboard" />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
